<template>
  <el-header class="main-layout-header" style="font-size: 12px">
    <el-row type="flex" justify="space-between">
      <el-col>
        <el-row type="flex" align="middle" style="height: 60px">
          <i v-if="!isCollapse" @click="() => handleMenu(true)" class="el-icon-s-fold" style="font-size: 24px; color: white; cursor: pointer"></i>
          <i v-if="isCollapse" @click="() => handleMenu(false)" class="el-icon-s-unfold" style="font-size: 24px; color: white; cursor: pointer"></i>
        </el-row>
      </el-col>
      <el-col>
        <el-row type="flex" justify="end">
          <el-dropdown trigger="click">
            <i class="el-icon-setting" style="margin-right: 15px; color: white"></i>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item>View</el-dropdown-item>
              <el-dropdown-item>Add</el-dropdown-item>
              <el-dropdown-item>Delete</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <el-dropdown trigger="click" @command="logoutUser">
            <span class="el-dropdown-link" style="color: white">
              {{ fullname }}
              <i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="d">Logout</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </el-row>
      </el-col>
    </el-row>
  </el-header>
</template>

<script>
import { mapState, mapActions } from "vuex";
export default {
  props: ['isCollapse', 'toggleMenu'],
  data: () => {
    const currentUser = localStorage.getItem("user");
    return {
      fullname: JSON.parse(currentUser).fullname,
    };
  },
  computed: {
    ...mapState({
      auth: state => state.auth
    })
  },
  methods: {
    ...mapActions({
      logout: "auth/logout"
    }),
    logoutUser() {
      this.logout();
    },
    handleMenu(e) {
      this.toggleMenu(e);
    }
  }
};
</script>